// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1dkT6","sendOtp":"AuthorizeToLogin_sendOtp__Fl8vm"};